export const getCurrentDateTime = () => {
  const now = new Date()
  const date = now.toLocaleDateString('th-TH', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
  const time = now.toLocaleTimeString()
  const currentDateTime = date + ' | ' + time

  return currentDateTime
}
